export function Divider() {
  return <div className="border-b border-[#D8DCDE] h-px" />;
}
